import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import ContainerCard from "../ContainerCard";
import parse from "html-react-parser";
const useStyles = makeStyles((theme) => ({
  root: {},

  description: {
    overflow: "hidden",
    display: "-webkit-box",

    // height: "22vh",
    textOverflow: "ellipsis",
    WebkitLineClamp: 7,
    WebkitBoxOrient: "vertical",
    [theme.breakpoints.down("md")]: {
      WebkitLineClamp: 7,

      fontSize: "0.8rem",
    },
  },
  link: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(0),
      // height: "50vh",
      backgroundColor: "red",
      // boxShadow: "0px 0px 20px rgba(0,0,0,0.1)",

      // backgroundColor: "red",
    },
  },
}));
const smallText = `વિશ્વ જ્યારે આધુનિક ટેકનોલોજી તરફ હરણફાળ પ્રગતિ કરી રહ્યું છે. જ્યાં "મેક ઇન ઇન્ડિયા–ડીજીટલ ઈન્ડિયા"અને "ડીજીટલ વિલેજ" તરફ ભારત આગળ વધી રહ્યું છે. ત્યારે અમે ગુજરાતની તમામ ગ્રામ પંચાયતો ને એક મંચ પર લાવી તેમની આગવી ઓળખ આપવાનો પ્રયત્ન કરી રહ્યા છીએ.`;
const AboutUs = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContainerCard
        title={props.title}
        link={props?.link}
        linkTitle={props?.linkTitle}
      >
        <Typography variant="body1" className={classes.description}>
          {/* {props?.description ? parse(props?.description) : "description"} */}
          {smallText}
        </Typography>
      </ContainerCard>
    </div>
  );
};
export default AboutUs;
